export default {
    common: {
        noData: '暂无数据',
        copy: '复制',
        copySuccess: '复制成功！',
        confirmText: '确认',
        cancelText: '取消',
        sendSuccess: '发送成功！',
        qrCodeDownloadApp: '扫码下载App'
    },
    login: {
        title: '登 录',
        enterUserName: '请输入电子邮箱/用户名',
        enterPassword: '请输入密码',
        enterLogin: '登录',
        forgotPassword: '忘记密码',
        register: '注册账号',
    },
    register: {
        title: '注 册',
        enterUserName: '用户名',
        enterPassword: '密码',
        enterEmail: '电子邮箱',
        enterCode: '邮箱验证码',
        inviteCode: '邀请码（可选）',
        sendEmailCode: '发送验证码',
        enterUserNameErr: '请输入用户名',
        enterUserNameErr2: '用户名由6～16位字母或数字组成',
        enterPasswordErr: '请输入密码',
        enterPasswordErr2: '密码由8~18位英文字母、数字、特殊符号组成',
        enterEmailErr: '请输入电子邮箱',
        enterEmailErr2: '请输入正确的电子邮箱',
        enterCodeErr: '请输入邮箱验证码',
        enterRegister: '注册',
        registerSuccess: '注册成功，即将跳转登录页面...',
        toLogin: '已有账号？直接登录',
        emailCodeTip: '如果您在收件箱中未收到邮件，那可能是被误判为垃圾邮件了，请去邮箱垃圾箱中查看。'
    },
    forgotPassword: {
        title: '忘 记 密 码',
        enterEmail: '电子邮箱',
        enterCode: '邮箱验证码',
        sendEmailCode: '发送验证码',
        enterEmailErr: '请输入电子邮箱',
        enterEmailErr2: '请输入正确的电子邮箱',
        enterCodeErr: '请输入邮箱验证码',
        enterPassword: '新密码',
        enterPasswordErr: '请输入新密码',
        enterPasswordErr2: '密码由8~18位英文字母、数字、特殊符号组成',
        enterBtn1: '取消',
        enterBtn2: '确认',
        forgotPasswordSuccess: '修改成功，即将跳转登录页面...'
    },
    layoutHeader: {
        login: '登录',
        register: '注册',
        nav: ['行情', '平台', '公链', '铭文', '爆仓', '聪明钱', '多空', '大户', '费率', '新闻', '应用'],
        navHyperliquid: 'Hyperliquid巨鲸监控',
        userNav1: '签到',
        userNav12: '钱包明细',
        userNav2: '提币',
        userNav13: '提币记录',
        userNav3: '合约检查',
        userNav4: '邀请链接',
        userNav5: '收藏',
        userNav6: '追踪',
        userNav7: '团队',
        userNav8: '工具',
        userNav9: '退出',
        userNav10: '绑定API',
        userNav11: '打新机器人',
        searchPlaceholder: '地址或币种查询',
        historyTitle: '历史搜索记录',
        searchTitle1: '合约',
        searchTitle2: '币种',
        searchList1_1: '名称',
        searchList1_2: '链上交易额',
        searchList1_3: '价格',
        searchList2_1: '名称',
        searchList2_2: '流通数量',
        searchList2_3: '价格',
        searchNoResult: '暂无搜索结果',
    },
    layoutTop: {
        topTitle1: '主流币行情参考',
        topTitle2: '情绪指标',
        sentimentIndexBlock1: '情绪指数',
        sentimentIndexBlock1_1: '极度恐慌',
        sentimentIndexBlock1_2: '恐慌',
        sentimentIndexBlock1_3: '中性',
        sentimentIndexBlock1_4: '贪婪',
        sentimentIndexBlock1_5: '极度贪婪',
        sentimentIndexBlock2: 'BTC持仓多空',
        sentimentIndexBlock2_1: '看多优势',
        sentimentIndexBlock2_2: '看空优势',
        trend24h: '24 小时走势',
        past24h: '过去 24 小时',
        candleSummary: 'BTC 最近 48 根 30 分钟收盘价走势',
        chartLoading: '正在加载走势…',
        chartUnavailable: '走势数据暂时无法加载',
        sentimentDetails: '查看详情',
        sentimentUnavailable: '暂无数据',
        btcRatio: 'BTC 多空比',
        ratioShare: '多 {long}% · 空 {short}%',
        moodHistory: '历史指数',
        moodRecentDays: '近 {count} 日',
        moodVsYesterday: '较昨日 {value}',
        moodUnchanged: '与昨日持平',
    },
    layoutSection: {
        title1: '聪明钱',
        title2: '辅助工具',
        titleMore: '更多>>',
    },
    layoutFooter: {
        appTitle: '超多应用下载',
        appNav1: '应用',
        appNav2: '钱包',
        appNav3: '社交',
        explain1: '免责声明：',
        explain2: '本网站的所有内容均来源于第三方平台,我们对于网站及其内容不做任何类型的保证,网站所有区块链相关数据与资料仅供用户学习及研究之用,不构成任何投资、法律等其他领域的建议和依据。您需谨慎使用相关数据及内容，并自行承担所带来的一切风险。强烈建议您独自对内容进行研究、审查、分析和验证。',
        copyright: '2026——最终解释权归 TokenTrend 所有'
    },
    coinDetails: {
        titleLabel1: '24H涨跌幅',
        titleLabel2: '24H最高价',
        titleLabel3: '24H最低价',
        titleLabel4: '交易量',
        titleLabel5: '24H成交额',
        titleLabel6: '24H开盘价',
        titleLabel7: '历史最低价',
        infoItem1: '币种：',
        infoItem2: '官网链接：',
        infoItem3: '历史最高价格：',
        infoItem4: '历史最低价格：',
        infoItem5: '流通量：',
        infoItem6: '发行总量：',
        infoItem7: '最大发行量：',
        infoItem8: '上市时间：',
        infoItem9: '价格起始时间：',
        infoItem10: '白皮书链接：',
    },
    newCoinDetails: {
        titleLabel0: '直达链接：',
        titleLabel1: '流通量',
        titleLabel2: '流通率',
        titleLabel3: '发售数量',
        titleLabel4: '发行总量',
        titleLabel5: '24小时涨幅',
        titleLabel6: '最新价格',
        titleLabel7: '发售价格',
        titleLabel8: '预售时间',
        titleLabel9: '上币平台',
        titleLabel10: '发售占比',
        listTitle: '市场行情',
        list1: '交易平台',
        list2: '币对',
        list3: '24H交易量',
        list4: '24H交易额($)',
        list5: '占比',
    },
    platformDetails: {
        title: '平台详情',
        website: '官网：',
        volumn24h: '24H交易额：',
        riseFall24h: '24H涨跌幅：',
        synopsis: '简介',
        content1: '成立时间',
        content2: '注册地',
        content3: 'KYC认证',
        content4: '量化接口',
        content5: '资产',
        content6: '交易对数量',
        isTrue: '是',
        isFalse: '否',
        lastLinkTitle1: '交易支持',
        lastLinkTitle2: '相关链接',
        content8: '现货交易',
        content9: '合约交易',
        content10: '场外交易',
        content11: '法币交易',
        title3: '相关链接',
        content12: 'Facebook',
        content13: 'Twitter',
        content14: 'Reddit',
        content15: 'Telegram',
    },
    firmOffer: {
        titleLabel0: '合约地址：',
        titleLabel1: '持币地址数',
        titleLabel2: '独立交易地址数',
        titleLabel3: '交易笔数',
        titleLabel4: '成交额',
        titleLabel5: '流动性',
        titleLabel6: '总市值',
        titleLabel7: '创建时间',
        titleLabel8: '总锁仓市值',
        tabs1: '交易历史',
        tabs2: '池子变化',
        tabs3: '持币地址',
        tabs4: '我的仓位',
        transactionTh1: '时间',
        transactionTh2: '类型',
        transactionTh3: '数量',
        transactionTh4: '价格',
        transactionTh5: '总价值',
        transactionTh6: '用户地址',
        transactionTh7: '交易hash',
        tag1: '买入',
        tag2: '卖出',
        tag3: '增加',
        tag4: '减少',
        poolTip: '默认显示第一个池子数据',
        poolTh1: '时间',
        poolTh2: '类型',
        poolTh3: '数量/代币',
        poolTh4: '总价值',
        poolTh5: '用户地址',
        poolTh6: '交易hash',
        poolCurrent: '总持币地址数',
        Explain1: '总持币地址数:',
        Explain2: '前10占比:',
        Explain3: '狙击手数:',
        Explain4: '可疑持币地址数:',
        positionTh1: '排名',
        positionTh2: '地址',
        positionTh3: '持有比例',
        positionTh4: '数量',
        positionTh5: '24小时变化',
        positionTh6: '区块信息',
        financeType1: 'Top 买家',
        financeType2: 'Top 卖家',
        financeTh1buy: '净买入',
        financeTh1sell: '净卖出',
        financeTh2buy: '买入金额($)',
        financeTh2sell: '卖出金额($)',
        financeTh3: '用户',
        addTrace: '确认追踪当前地址吗？',
        addTraceSuccess: '添加成功！',
    },
    market: {
        tabs1: '热门',
        tabs2: '涨幅',
        tabs3: '跌幅',
        tabs4: '新币',
        tabs5: '飙升',
        tabs6: '市值',
        tabs7: '成交额',
        popularListTh0: '序号',
        popularListTh1: '币种',
        popularListTh2: '最新价',
        popularListTh3: '24H涨幅',
        popularListTh4: '24H交易量',
        popularListTh5: '24H成交额',
        popularListTh6: '流通市值',
        popularListTh7: '上市时间',
        // ETF相关字段
        etfTh1: 'ETF名称',
        etfTh2: '基金类型',
        etfTh3: '净值(USD)',
        etfTh4: '溢价率(%)',
        etfTh5: 'BTC持仓',
        etfTh6: '管理费率(%)',
        etfTh7: '成交量(USD)',
        etfTh8: '资产规模(USD)',
    },
    platform: {
        tab1: '全球交易所资产排行',
        ERGlobalRankingListTh1: '序号',
        ERGlobalRankingListTh2: '平台',
        ERGlobalRankingListTh3: '资产($)',
        ERGlobalRankingListTh4: '24H交易额($)',
        ERGlobalRankingListTh5: '24H涨跌',
        ERGlobalRankingListTh6: '官网',
    },
    publicChain: {
        tableTh1: '配对',
        tableTh2: '价格/成交额',
        tableTh3: '涨跌幅/市值',
        tableTh4: '交易比数',
        tableTh5: '交易地址/持币数',
        tableTh6: '流动性/时间'
    },
    inscription: {
        typeAll: '全部',
        tableTh1: '代币名称',
        tableTh2: '持有人',
        tableTh3: '总交易次数',
    },
    burst: {
        title6: '清算地图',
        currentPrice: '当前价格：',
        liquidationTip1: '累计多单清算强度',
        liquidationTip2: '累计空单清算强度',
        liquidationTip3: '10x杠杆',
        liquidationTip4: '25x杠杆',
        liquidationTip5: '50x杠杆',
        liquidationTip6: '100x杠杆',
        title1: '爆仓热力图',
        heatmapTop: '综合Binance、Huobi、OKX三大交易所数据，{0}USDT爆仓最大点位在{1}附近，爆仓价值为{2}USDT，请注意资金风险',
        heatmapDetailsBtn: '详情',
        heatmapKLine1: 'k线',
        heatmapKLine2: '清算强度',
        heatmapTip1: '价格',
        heatmapTip2: '清算强度',
        kLineTip1: '开盘价',
        kLineTip2: '收盘价',
        kLineTip3: '最高价',
        kLineTip4: '最低价',
        noLogin: '点击右上方登录，登陆后即可查看热力图',
        title2: '爆仓数据',
        topBlockH41: '4H爆仓',
        topBlockH42: '12H爆仓',
        topBlockH43: '24H爆仓',
        topBlockP1: '爆仓额度',
        topBlockP2: '多单占比',
        title3: '24H爆仓排行',
        rankingTh1: '交易所',
        rankingTh2: '币种',
        rankingTh3: '爆仓USD',
        rankingTh4: '多单USD',
        rankingTh5: '空单USD',
        title4: '各币种爆仓统计',
        title5: '全网交易所爆仓占比',
        burstStatisticsHistoryTitle: '币种爆仓历史统计信息',
        burstStatisticsHistoryTh1: '币种',
        burstStatisticsHistoryTh2: '多单爆仓',
        burstStatisticsHistoryTh3: '空单爆仓',
        burstStatisticsHistoryTh4: '时间',
        heatmapDetailsTitle: '爆仓热力图数据',
        heatmapDetailsList1Top: '空',
        heatmapDetailsList1Bottom: '多',
        heatmapDetailsList1: '方向',
        heatmapDetailsList2: '价格',
        heatmapDetailsList3: '清算',
    },
    smartMoney: {
        typeTitle1: 'Top 100 高频交易',
        typMsg1: '8大公链综合收益/收益率排名前100',
        typeTitle2: '明星聪明钱',
        typMsg2: '全球知名人士/公链创始人/知名机构地址追踪',
        typeTitle3: '一级聪明钱',
        typMsg3: '一级市场收益率较高/较稳定的聪明钱',
        typeTitle4: '自定义聪明钱',
        typMsg4: '用户自行添加的追踪钱包地址',
    },
    smartMoneyTop100: {
        topTip: '综合各大DEX近30天分析数据。余额仅供参考！',
        sort: '序号',
        address: '地址',
        amountUsd: '余额',
        floatProfit: '浮盈',
        floatProfitPercent: '浮盈率',
        profit: '盈利',
        profitPercent: '盈利率',
        collectTo: '收藏',
        collectCancel: '取消收藏',
        noLogin: '登录后可查看追踪全球前100位收益最高的聪明钱，',
        toLogin: '去登录',
    },
    smartMoneyStar: {
        th1: '名称：',
        th2: '地址：',
        th3: '时间：',
    },
    smartMoneyOneLevel: {
        th1: '地址：',
        th2: '时间：',
    },
    smartMoneyCustom: {
        sort: '序号',
        name: '名称',
        address: '地址',
        time: '时间',
        addNameRules: '请输入名称',
        addAddressRules: '请输入地址',
        addConfirm: '确认',
        addSuccess: '添加成功！',
        addBtn: '新增自定义',
        delBtn: '删除',
        delSuccess: '删除成功！',
    },
    smartMoneyDetails: {
        type1: 'DEX交易',
        queryTokenAll: '全部',
        dexAddress: '地址：',
        dexHash: '交易hash：',
        dexChainName: '链名称：',
        dexTransactionAmount: '交易价值：',
        dexTrackerIn: '转入合约：',
        dexTrackerOut: '转出合约：',
        dexTrackerType: '交易方向：',
        dexTrackerTypeCon: '{0}{1} 兑换为 {2}{3}',
        dexTransactionTime: '交易时间：',
        type2: '普通转账',
        ordinaryHash: '交易hash：',
        ordinaryTime: '时间：',
        ordinaryFrom: '发送者地址：',
        ordinaryTo: '接收者地址：',
        ordinarySymbol: '币种名称：',
        ordinaryAmount: '转账数量：',
    },
    manyEmpty: {
        title1: '全球账户多空比',
        title2: '顶级账户多空比',
        title3: '顶级账户持仓多空比',
        progress1: '多头：',
        progress2: '空头：',
        tableTh1: '交易所',
        tableTh2: '多空比',
        tableTh3: '多头占比',
        tableTh4: '空头占比',
    },
    whale: {
        holdingsTitle: '灰度持仓列表',
        holdingsTitle2: '更新时间：',
        holdingsTh1: '持仓变化',
        holdingsTh1_1: '1天',
        holdingsTh1_2: '7天',
        holdingsTh1_3: '30天',
        holdingsTh2: '溢价率',
        holdingsTh3: '持仓币种数量',
        holdingsTh4: '持仓价值',
        contractTitle: '合约总持仓',
        contractTh1: '交易所',
        contractTh2: '持仓价值($)',
        contractTh3: '持仓数量',
        contractTh4: '15分钟变化',
        contractTh5: '1天变化',
        exchangeTitle: '交易所余额清单',
        exchangeTh1: '交易所',
        exchangeTh2: '钱包数量',
        exchangeTh3: '24H变化',
        exchangeTh4: '7天变化',
        exchangeTh5: '30天变化',
        statistics1: '总市值：',
        statistics2: '24小时交易量：',
        statistics3: '24小时最高价：',
        listRight1: '时间',
        listRight2: '转出地址',
        listRight3: '转入地址',
        listRight4: '转账数量',
    },
    rate: {
        newTitle: '交易所当前资金费率列表',
        newTableTh1: '币种',
        newTableTd1: '预测费率',
        oldTableTh1: '交易所',
        oldTableTh2: '当前费率',
        oldTableTh3: '最高费率',
        oldTableTh4: '最低费率',
        oldTableTh5: '更新时间',
    },
    consult: {
        nav1: '快讯',
        nav2: '公告',
        nav3: '新闻',
        detailsTime: '时间',
        detailsBack: '返回',
        details: '详情',
    },
    application: {
        nav1: '应用',
        nav2: '钱包',
        nav3: '社交',
        visit: '前往',
        empty: '暂无内容',
        download: '下载',
        register: '注册'
    },
    userSignIn: {
        alreadySignIn: '已签到{0}天',
        signInBtn: '立即签到',
        tip1: "浏览平台{0}分钟，即可领取签到奖励",
        tip2: '（您已浏览{0}分钟{1}秒）',
        success: '签到成功！',
        recordTitle: '签到记录',
        recordListContent: '时间：',
    },
    userSignInRecord: {
        title: '钱包明细',
        selectAll: '全部',
        typeSelect1: '签到奖励',
        typeSelect2: '直推奖励',
        typeSelect3: '团队奖励',
        typeSelect4: '申请提现扣除',
        typeSelect5: '系统驳回增加',
        th1: '类型',
        th2: '数量',
        th3: '时间',
    },
    userWithdrawal: {
        titleTip: '提款地址必须是TRON（TRC-20）链的钱包地址。填写其他链的钱包地址将导致永久丢失且无法恢复。',
        withdrawalAddress: '您的提款地址：',
        inputWithdrawalAddress: '请输入提款地址',
        number: '数量',
        inputNumber: '请输入数量',
        inputNumberErr: '余额不足',
        balance: '余额',
        actualReceipt: '实际到账：',
        gas: '手续费：',
        tip: '最低提取{0}USDT，提现手续费{1}%。',
        confirm: '确定',
        explain: '网络交易需要0-2小时，且网络确认不包括在内',
        submitSuccess: '提交成功'
    },
    userWithdrawalRecord: {
        title: '提币记录',
        list1: '地址',
        list2: '网络',
        list3: '币种',
        list4: '数量',
        list5: '手续费',
        list6: '状态',
        list7: '时间',
        status0: '待审核',
        status1: '通过',
        status2: '驳回',
    },
    userContractCheck: {
        enterPlaceholder: '请输入合约地址',
        enterBtn: '检查',
        riskAssessment: '风险评估',
        riskInspection: '风险检查',
        checkNFT1: ['无恶意NFT', '恶意NFT'],
        checkNFT2: ['未开源', '已开源'],
        checkNFT3: ['无代理合约', '有代理合约'],
        checkNFT4: ['未验证', '已验证'],
        checkNFT5: ['不是著名的、值得信赖的NFT', '著名的、值得信赖的NFT'],
        checkToken1: ['不具有修改最大交易金额或最大代币持仓的功能', '具有修改最大交易金额或最大代币持仓的功能'],
        checkToken2: ['所有权不可以收回', '所有权可以收回'],
        checkToken3: ['合约无隐藏所有者', '合约有隐藏所有者'],
        checkToken4: ['不具有限制单个地址最大交易量或最大持仓量的功能', '具有限制单个地址最大交易量或最大持仓量的功能'],
        checkToken5: ['令牌不是蜜罐', '令牌是蜜罐'],
        checkToken6: ['代币不可以在去中心化交易所交易', '代币可以在去中心化交易所交易'],
        checkToken7: ['合约没有能力铸造代币', '合约有能力铸造代币'],
        checkToken8: ['未开源', '已开源'],
        checkToken9: ['不是代理', '是代理'],
        checkToken10: ['合约所有者不可以更改代币持有者余额', '合约所有者可以更改代币持有者余额'],
        checkToken11: ['不可以为每个分配的地址设置不同的税率', '可以为每个分配的地址设置不同的税率'],
        checkToken12: ['合约不可以自毁', '合约可以自毁'],
        checkToken13: ['合约不具有交易冷却机制', '合约具有交易冷却机制'],
        checkToken14: ['不可以通过代币合约暂停交易', '可以通过代币合约暂停交易'],
        checkToken15: ['该代币不是著名且值得信赖的代币', '该代币是著名且值得信赖的代币'],
        botToken1: '所有者地址',
        botToken2: '所有者的余额',
        botToken3: '所有者持有代币的百分比',
        botToken4: '供应数量',
        botNFT1: '总交易量',
        botNFT2: '持有者数量',
        botNFT3: '最高价格',
        botNFT4: '24小时平均价格',
        botNFT5: '24小时最低价格',
    },
    userCollect: {
        title: '收藏',
        sort: '序号',
        address: '地址',
        amountUsd: '余额',
        floatProfit: '浮盈',
        floatProfitPercent: '浮盈率',
        profit: '盈利',
        profitPercent: '盈利率',
        cancel: '取消收藏',
        cancelSuccess: '取消成功！',
    },
    userTrace: {
        title: '追踪',
        th1: '序号',
        th2: '公链名称',
        th3: '代币名称',
        th4: '地址',
        del: '删除',
        delSuccess: '删除成功！',
    },
    userTeam: {
        title: '团队',
        topInfo1: '直推人数',
        topInfo2: '团队人数',
        topInfoUnit: '人',
        th1: '用户名：',
        th2: '注册时间：',
    },
    userTool: {
        tool1: 'BTC公司持仓',
        tool2: '情绪指数',
        tool3: '门头沟监控',
        tool4: '场外价格',
        tool5: '外盘数据',
        tool6: '大户增仓',
        tool7: '大户减仓',
        tool8: '稳定币',
        tool9: '区块链浏览器',
    },
    userToolCompanyHoldings: {
        title: '全球公司BTC持仓数据',
        globalDataT1: 'BTC持仓公司',
        globalDataD1: '家',
        globalDataT2: '公司总持仓',
        globalDataD2: '近7日变化：',
        globalDataT3: '持仓总价值',
        globalDataD3: '近7日变化：',
        globalDataT4: '持仓占BTC总市值',
        globalDataD4: '7日前占比：',
        th1: '公司名称',
        th2: '持仓价值($)',
        th3: '占BTC市值',
        th4: '持仓BTC',
        th5: '近7日持仓变化',
        th6: '总持仓成本',
        th7: '平均成本($)',
    },
    userToolSentimentIndex: {
        title1: '恐慌与贪婪指数',
        title1_1: 'BTC与重要主流币的恐慌与贪婪指数',
        gauge1: '极度恐慌',
        gauge2: '恐慌',
        gauge3: '中性',
        gauge4: '贪婪',
        gauge5: '极度贪婪',
        title2: '历史指数',
    },
    userToolMTGoxMonitor: {
        time: '更新时间：',
        title1: '门头沟(MTGox)BTC冷钱包',
        topLabel1: '原持有BTC总量',
        topLabel1Span: '原价值',
        topLabel2: '现剩余BTC总量',
        topLabel2Span: '现价值',
        topLabel3: '持有BTC变化量',
        title2: 'BTC冷钱包链上转出记录',
        th1: '交易时间',
        th2: '冷钱包地址',
        th3: '转账BTC数量',
    },
    userToolOutsidePrice: {
        th1: '代币名称',
        th2: '交易所',
        th3: '成交均价',
        th4: '溢价',
    },
    userToolOutsideDisk: {
        itemTitleSpan: '更新',
        itemTitle2: '开盘时间：',
        itemInfo1: '昨收',
        itemInfo2: '今开',
        itemInfo3: '今日成交量',
        itemInfo4: '今日最高',
        itemInfo5: '今日最低',
        itemInfo6: '近一年最高',
        itemInfo7: '近一年最低',
    },
    userToolLargeIncrease: {
        title: '大户增仓',
        titleMsg: '多个或单个币种不同的时间段，自动计算币种在所选时间段内的涨跌幅',
        th1: '币种',
        th2: '24H涨跌',
        th3: '24H持仓占比',
        th4: '周持仓占比',
        th5: '月持仓占比',
        th6: '全球指数($)',
        th7: '前10持仓占比',
        th8: '前20持仓占比',
        th9: '前50持仓占比',
        th10: '前100持仓占比',
    },
    userToolLargeDecrease: {
        title: '大户减仓',
        titleMsg: '多个或单个币种不同的时间段，自动计算币种在所选时间段内的涨跌幅',
        th1: '币种',
        th2: '24H涨跌',
        th3: '24H持仓占比',
        th4: '周持仓占比',
        th5: '月持仓占比',
        th6: '全球指数($)',
        th7: '前10持仓占比',
        th8: '前20持仓占比',
        th9: '前50持仓占比',
        th10: '前100持仓占比',
    },
    userToolStableCoin: {
        tab1: 'USDT 行情',
        UsdTopInfo1: 'USDT场外均价',
        UsdTopInfo2: '美元汇率',
        UsdTopInfo3: 'USDT溢价率',
        UsdTitleSub1: 'USDT相关指数走势',
        UsdTitleSub2: 'USDT溢价相关走势',
        UsdQuery1: '7天',
        UsdQuery2: '30天',
        tab2: '相关稳定币',
        relatedTitleSub1: '稳定币概况',
        relatedTopTh1: '币种',
        relatedTopTh2: '场外均价($)',
        relatedTopTh3: '溢价率',
        relatedTopTh4: '当前流通量',
        relatedTopTh5: '流通市值($)',
        relatedQuery1: '30天',
        relatedQuery2: '近一年',
        relatedTitleSub2: '稳定币流通量',
        relatedTitleSub3: '稳定币流通量占比',
        relatedTitleSub4: '稳定币链上发行',
        relatedBottomTh1: '时间',
        relatedBottomTh2: '币种/主网',
        relatedBottomTh3: '发行数量',
        relatedBottomTh3_1: '增发',
        relatedBottomTh3_2: '销毁',
        relatedBottomTh4: '交易哈希',
    },
    userToolBlockChainBrowser: {
        title: '区块链浏览器'
    },
    bindingApi: {
        bindBtn: '绑定API',
        tip: '交易所创建API要求必须绑定IP',
        listTitle: '绑定列表',
        list1: '解绑',
        list2: '可用余额：',
        enterBourse: '选择交易所：',
        enterNotes: '备注:',
        enterBourseErr: '请选择交易所',
        enterApiKeyErr: '请输入Api key',
        enterSecretKeyErr: '请输入Secret key',
        enterPassphraseErr: '请输入PassPhrase(OKX必填)',
        enterNotesErr: '请输入备注',
        bindSubmit: '提交',
        bindSuccess: '绑定成功',
        unBindSuccess: '解绑成功'
    },
    hitNewRobot: {
        top1: '智慧时代，领创科技未来',
        top2: '打新机器人9月30日正式上线',
        topBtn: '游戏规则>>',
        hitNewTitle: '交易所打新列表',
        hitSelTitle: '请选择区块',
        hitNewlistTh1: '代币信息',
        hitNewlistTh2: '代币价格',
        hitNewlistTh3: '初始流动',
        hitNewlistTh4: '流动资金总额',
        hitNewlistTh5: 'pool金额',
        hitNewlistTh6: '池',
        hitNewlistTh7: '剩余',
        hitNewlistTh8: '上市以来',
        createBtn: '创建',
        createTitle: '创建机器人',
        createLabel1: '交易所名称：',
        createLabel2: '币对所名称：',
        createLabel3: '上币时间：',
        createLabel7: '可用余额：',
        createLabel4: '预计购买数量：',
        createLabel5: '预计购买价格：',
        createLabel6: '抢购时间：',
        createLabel4Err: '请输入预计购买数量',
        createLabel5Err: '请输入预计购买价格',
        createLabel6Err: '请选择抢购时间',
        createTip: '购买价值必须>=10USDT',
        createSuccess: '创建成功！',
        robotTitle: '机器人列表',
        robotListStatus1: '待执行',
        robotListStatus2: '已结束',
        robotListBinanceStatus1: '挂单成功',
        robotListBinanceStatus2: '挂单失败',
        robotList1: '执行时间：',
        robotList2: '取消机器人',
        robotList3: '币对',
        robotList4: '价格',
        robotList5: '数量',
        robotCancel: '取消成功',
    },
    hitNewRobotRule: {
        title: '返回',
        h2_1: '核心优势：',
        label1_1: '高效算法：',
        label1_2: '深度整合：',
        label1_3: '大数据处理：',
        label1_4: '智能策略：',
        label1_5: '安全保障：',
        label1_6: '自动化交易：',
        label1_7: '优化体验：',
        p1_1: '内置高效算法，毫秒级交易决策，精准捕捉市场动态。',
        p1_2: '整合Binance、HTX、OKX等主流交易所API，确保数据全面准确。',
        p1_3: '利用Apache Kafka与Flink技术，实时收集并处理市场数据。',
        p1_4: '结合TensorFlow或PyTorch框架，利用历史数据与趋势优化打新策略。',
        p1_5: '分布式架构，多重加密技术，保障用户数据与交易安全。',
        p1_6: '未来探索智能合约与跨链技术，实现DEX自动化交易与高效资产管理。',
        p1_7: '持续优化界面与交互设计，提供直观数据可视化工具，提升用户体验。',
        h2_2: '会员升级标准：',
        label2_1: 'v0 → v1：',
        label2_2: 'v1 → v2：',
        label2_3: 'v2 → v3：',
        label2_4: 'v3 → v4：',
        label2_5: 'v4 → v5：',
        label2_6: 'v5 → v6：',
        label2_7: 'v6 → v7：',
        p2_1: '直推3人，团队达到100人。',
        p2_2: '直推5人，团队达到200人。',
        p2_3: '直推5人，其中两人达到v2。',
        p2_4: '直推5人，其中两人达到v3。',
        p2_5: '直推5人，其中两人达到v4。',
        p2_6: '直推5人，其中两人达到v5。',
        p2_7: '直推5人，其中两人达到v6。',
        h2_3: '机器人发放标准：',
        label3_1: 'V1',
        label3_2: 'V2',
        label3_3: 'V3',
        label3_4: 'V4',
        label3_5: 'V5',
        label3_6: 'V6',
        label3_7: 'V7',
        p3_1: '获得1个机器人。',
        p3_2: '获得3个机器人。',
        p3_3: '获得5个机器人。',
        p3_4: '获得6个机器人。',
        p3_5: '获得7个机器人。',
        p3_6: '获得9个机器人。',
        p3_7: '获得10个机器人，并额外赠送5个，总计15个机器人。',
        h2_4: '机器人有效运行条件：',
        label4_1: '持续签到：',
        label4_2: '激活条件：',
        label4_3: '签到中断：',
        p4_1: '会员需保持每日签到，以确保机器人有效运行。',
        p4_2: '仅连续签到会员可激活打新服务。',
        p4_3: '若当日漏签，次日打新机器人将停止运行，恢复签到后次日零点自动激活。',
        h2_5: '总结：',
        p5: '本平台数字货币打新机器人模块，通过高效算法与智能策略，为会员提供自动化、高效、安全的打新服务。随着技术的不断进步，我们将持续优化用户体验，拓展更多元化的打新选择，助力会员实现资产增值。'
    },
    invite: {
        title: '邀请好友',
        info1: '邀请好友加入注册/团队',
        info2: '有机会获得开启机器人机会/推广收益',
        info3: '嗨！欢迎来到 TokenTrend 平台',
        info4: '专为币圈新手定制 全新工具一键上手',
        btn: '复制邀请链接'
    },
    hyperliquid: {
        searchPlaceholder: '输入钱包地址查询持仓信息...',
        searchBtn: '查询',
        title: '鲸鱼仓位监控',
        dataCount: '共 {0} 个大户持仓',
        long: '做多',
        short: '做空',
        cross: '全仓',
        isolated: '逐仓',
        positionValue: '仓位价值',
        positionSize: '仓位大小',
        entryPrice: '开仓价格',
        markPrice: '标记价格',
        unrealizedPnl: '未实现盈亏',
        noData: '暂无数据',
        enterAddress: '请输入钱包地址',
        enterValidAddress: '请输入有效的钱包地址',
        copyAddress: '复制地址',
        whale: '巨鲸',
        explorer: '浏览器',
        accountTotalValue: '账户总价值',
        perpetual: '永续合约',
        freeMarginAvailable: '可用保证金',
        withdrawable: '可提取',
        totalPositionValue: '持仓总价值',
        leverageRatio: '杠杆倍数',
        marginUsed: '已用保证金',
        usedRatio: '使用率',
        perpTotalValue: '永续持仓总价值',
        positionsCount: '{0} 个仓位',
        avgMarginUsedRatio: '平均保证金使用率',
        directionBias: '方向偏向',
        longExposure: '多头敞口',
        shortExposure: '空头敞口',
        positionDistribution: '仓位分布',
        longValue: '多头价值',
        shortValue: '空头价值',
        roe: 'ROE',
        upnl: '未实现盈亏',
        perpPositions: '永续仓位 ({0})',
        symbol: '币种',
        entryAvgPrice: '开仓均价',
        margin: '保证金',
        fundingCost: '资金费用',
        noPositions: '暂无持仓',
        userAddressRequired: '用户地址不能为空',
        addressCopied: '地址已复制',
        copyFailed: '复制失败',
        bullish: '看多',
        bearish: '看空',
        neutral: '中性'
    }
}